import { createFileRoute } from '@tanstack/react-router';
import { MasterConfigScreen } from '@/mobile/master/screens/MasterConfigScreen';

export const Route = createFileRoute('/m/master/config')({
  component: MasterConfigScreen,
});
